import Vue from 'vue';
import ClipBoard from 'v-clipboard';

Vue.use(ClipBoard);
